import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding: ${space[5]};
  background: ${colors.lighterGrey};
  border: 1px solid ${colors.borderGreyLighter};
  border-radius: ${layout.borderRadiusLg};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  flex: 1;
  min-width: 0;
`;

export const Title = styled.p`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.bold};
  font-size: ${fonts.size.base};
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const Subtitle = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
  margin: 0;
`;

export const CtaWrapper = styled.div`
  flex-shrink: 0;
`;
